
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import CircularProgress from '@mui/material/CircularProgress';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';


import { useState } from 'react';
import styled from "styled-components";

import Config from '../config.json';

import { setCookie } from '../Helpers';

import background from '../dion-beetson-oF7hh97lVqA-unsplash.jpg';
import { Link } from '@mui/material';

export default function Login({ setIsForgot }) {

    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [email, setEmail] = useState("");
    const [message, setMessage] = useState("");
    const [open, setOpen] = useState(false);

    const url_forgot = "../api/auth/forgot";

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setOpen(false);
    };

    const handleSubmit = (e) => {

        e.preventDefault();
        if (!loading) {
            setSuccess(false);
            setLoading(true);
            postData();

            //timer.current = window.setTimeout(() => {
            //    setSuccess(true);
            //    setLoading(false);
            //}, 2000);
        }
    };

    function validateForm() {
        return !loading && email.length > 0;
    }


    const postData = async () => {

        try {
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    "email": email
                })
            };

            const response = await fetch(url_forgot, requestOptions)
            var json = await response.json();
            if (json.status === 'success') {
                    setSuccess(true);
                    setLoading(false);
                    setOpen(true);
                    setMessage("Email is successfully sent");
                    //setAuth(true);
                    //window.setTimeout(() => {
                        //window.location.reload();
                    //    setIsForgot(false);
                    //}, 2000);
                    //
            } else {
                setSuccess(false);
                setLoading(false);
                setOpen(true);
                //setAuth(false);
                setMessage(`Error ${json.message}`);
            }
        } catch (error) {
            setSuccess(false);
            setLoading(false);
            setOpen(true);
            //setAuth(false);
            setMessage(`Error ${error}`);
        }
    };


    return (
    <>
        <Container>
            <Centered>
                <Header>
                    <Title>Forgot Password</Title>
                </Header>
                <form onSubmit={(e) => handleSubmit(e)}>
                    <InputWrap>
                        <TextField required id="email" type="email" autoComplete="off" label="email" color="secondary" size="small" value={email} onChange={e => setEmail(e.target.value)} />
                    </InputWrap>
                    <ButtonWrapper>
                        <ButtonLogin fullWidth variant="outlined"
                            type="submit" disabled={!validateForm()}
                        >
                            Send to Email
                        </ButtonLogin>
                        <br /> <br />
                        <ButtonLogin fullWidth variant="outlined"
                            type="button"  onClick={()=>setIsForgot(false)}
                        >
                            Cancel
                        </ButtonLogin>
                        {loading && <CircularProgressExt size={24} />}
                    </ButtonWrapper>
                </form>
            </Centered>
            <Snackbar open={open} autoHideDuration={8000} onClose={handleClose} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
                {success ?
                    <Alert onClose={handleClose} severity="success">
                        {message}
                    </Alert>
                    :
                    <Alert onClose={handleClose} severity="error">{message}</Alert>
                }
            </Snackbar>
       
        </Container>
     
        </>
    )
}
/*
     
*/
const Container = styled.div`
  background-color: antiquewhite;
  height:90vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-image:url(${background});
  background-size: cover;
  background-position: center;
`;
/*
  backgroundImage: `url(${background})`,
  backgroundSize: 'cover',
  backgroundPosition: 'center',
*/
const Centered = styled.div`
   width: 250px;
   height: 300px;
   background-color: white;
   position: absolute;
   margin: auto;
   border-radius: 10px;
`;

const Header = styled.div`
  padding-top: 15px;
`;

const Title = styled.h3`
  border-left: solid 5px #009edb;
  color: #009edb;
  padding-left: 10px;
`;

const InputWrap = styled.div`
  padding-top: 1em;
  padding-left: 1em;
  padding-right: 1em;
`;

const ButtonWrapper = styled.div`
  position: relative;
  padding-top: 2em;
  padding-left: 1em;
  padding-right: 1em;
`;
const ForgotWrapper = styled.div`
  position: relative;
  text-align: center;
  padding-top: 0.2em;
`;

const ButtonLogin = styled(Button)`
  :hover{
      background-color: #EF4C4C!important;
      color: white;
  }
`;

const CircularProgressExt = styled(CircularProgress)`
    color: green;
    position: absolute;
    top: 50%;
    left: 50%;
    margin-top: 5px;
    margin-left: -12px;
`;

/*


   buttonProgress: {
       color: green[500],
       position: 'absolute',
       top: '50%',
       left: '50%',
       marginTop: 5,
       marginLeft: -12,
   },
   buttonSuccess: {
       backgroundColor: green[500],
       color: "white",
       border: "none",
       '&:hover': {
           backgroundColor: green[700],
       },
   },
   icon: {
       fontSize: "16px",
       marginLeft: "-10px",
       marginRight: "5px"
   }
 //backgroundImage: url(${background}),
 //backgroundSize: 'cover',
 //backgroundPosition: 'center',
 //backgroundColor: "darkgrey",
 */